import { createContext, useContext } from "react";

export interface LayoutCollapseContextType {
  isHeaderCollapsed: boolean;
  isSubheaderCollapsed: boolean;
  isLegendCollapsed: boolean;

  toggleHeader: () => void;
  toggleSubheader: () => void;
  toggleLegend: () => void;
}

export const LayoutCollapseContext =
  createContext<LayoutCollapseContextType | null>(null);

export const useLayoutCollapseContext = (): LayoutCollapseContextType => {
  const context = useContext(LayoutCollapseContext);

  if (!context) {
    throw new Error(
      "useLayoutCollapseContext must be used within LayoutCollapseProvider"
    );
  }

  return context;
};
